import { EmailStatus } from '@brickup/shared/enums'
import {
  FILTER_ALL,
  oneOf,
  stringFilter,
  type AllOr,
} from '@/components/Internal/DataTable'

export type StatusFilter = EmailStatus | undefined

export const emailLogFilters = {
  status: oneOf<StatusFilter>(EmailStatus, undefined),
  search: stringFilter(),
}

export type SubscriptionFilter = AllOr<'subscribed' | 'unsubscribed'>

export const subscriptionFilters = {
  status: oneOf<SubscriptionFilter>(
    [FILTER_ALL, 'subscribed', 'unsubscribed'],
    FILTER_ALL,
  ),
  search: stringFilter(),
}
